import { tryCatch } from '../../shared/utils/tryCatch';
import { clientFetch, Uri, withSessionToken } from '../utils/fetch';
import { urlUtils } from '../utils/url';

export const fetchLabels = async (siteSettings, alias) => {
  const { siteId, baseUrl } = siteSettings;

  const url = `${baseUrl}/api/attribute-collection?siteId=${siteId}&alias=${alias}`;
  const [error, response] = await tryCatch(async () => {
    return fetch(url, {
      method: 'GET',
      headers: withSessionToken(),
    });
  });

  if (error) {
    console.error('Error fetching labels:', error);
    return {};
  }

  if (!response.ok) {
    console.error('Error fetching labels:', response.statusText);
    return {};
  }

  const labels = await response.json();
  return {
    ...labels,
    general: labels.iwGeneral,
    errors: labels.iwErrors,
    priceDetails: labels.iwPriceDetails,
  };
};

export const fetchDestinationContent = async (siteSettings) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const areaCaId = urlUtils.getAreaIdFromUrl();
  const resortCaId = urlUtils.getResortIdFromUrl();
  const hasAreaId = areaCaId > 0;

  const areaWvId = urlUtils.getAreaWvIdFromUrl();
  const resortWvId = urlUtils.getResortWvIdFromUrl();
  const hasAreaWvId = areaWvId > 0;

  const type = hasAreaId || hasAreaWvId ? 'area' : 'resort';

  const uri = new Uri({
    domain: apiUrl,
    path: `/api/content/${type}`,
    query: {
      caId: hasAreaId ? areaCaId : resortCaId,
      wvID: hasAreaWvId ? areaWvId : resortWvId,
      siteId,
    },
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};
